<template>
    <div class="btn_group">
      <button title="添加事件" @click="add_item" tabindex="-1">+</button>
      <button title="删除当前" @click="remove_item" tabindex="-1">-</button>
      <!-- <button>+</button> -->
    </div>
    
</template>

<script>
export default {
   name:'BayItemEdit',
   props:{
       index:Number
   },
   methods: {
       add_item(){
           this.$emit('add_item',this.index);
       },
       remove_item(){
           this.$emit('remove_item',this.index);
       }
   },
}
</script>

<style lang="stylus" scoped>
@import '~css/mixins.styl';
@import '~css/var.styl';
.btn_group
    display:flex;
    position:absolute;
    top:10%;
    right:0%;
    width:0px;
    flex-direction :column;
    overflow hidden

    transition:width 1s;


    &button
        clear_default_style()
        border-radius:2px;
        margin:2px 0px;
        center();
        // &:hover
        //     border:1px solid green;
    




</style>
